export default {
	en: "Eng",
	ru: "Rus"
  }